import { components } from '@/types/api';
import { useCallback } from 'react';
import { Button } from '../ui/button';
import { useAddReceiptContext } from '@/providers/AddReceiptContext';
import { format } from 'date-fns';
import SingleReceipt from '@/assets/icons/single_receipt.svg?react';
import AddReceipt from '@/assets/icons/Receipt_Add.svg?react';
import { Link } from 'wouter';

export function TransactionBlock({
  transaction,
}: {
  transaction: components['schemas']['AccountActivity'];
}) {
  const TransactionComponent = useCallback(() => {
    switch (transaction.status) {
      case 'receipt_matched':
        return <ReceiptMatchedTransaction transaction={transaction} />;
      case 'pending_receipt':
        return <PendingReceiptTransaction transaction={transaction} />;
      default:
        return null;
    }
  }, [transaction]);

  return (
    <>
      <div className="flex flex-row items-center justify-between border-b border-gray-100 pr-5 pb-2 pl-3">
        <TransactionComponent />
      </div>
    </>
  );
}

function ReceiptMatchedTransaction({
  transaction,
}: {
  transaction: components['schemas']['AccountActivity'];
}) {
  return (
    <>
      <div className="flex flex-row items-center gap-5">
        <div className="bg-primary-platinum flex h-8 w-8 shrink-0 items-center justify-center rounded">
          <SingleReceipt />
        </div>
        <div className="flex flex-col">
          <h4 className="font-bold">{transaction.merchant_name}</h4>
          <span className="text-xs opacity-70">
            {format(new Date(transaction.transaction_date), 'EEEE')}
          </span>
          <Link
            href={`/receipts/${transaction.receipt_id}`}
            className="text-primary text-xs font-bold"
          >
            View receipt
          </Link>
        </div>
      </div>
      <p>${transaction.amount}</p>
    </>
  );
}

function PendingReceiptTransaction({
  transaction,
}: {
  transaction: components['schemas']['AccountActivity'];
}) {
  const { onUploadClick } = useAddReceiptContext();
  return (
    <>
      <div className="flex flex-row items-center gap-5">
        <div className="bg-secondary-notice flex h-8 w-8 shrink-0 items-center justify-center rounded">
          <AddReceipt />
        </div>
        <div className="flex flex-col">
          <h4 className="font-bold">{transaction.merchant_name}</h4>
          <div className="flex flex-row items-center gap-1.5">
            <span className="bg-secondary-notice rounded px-1.5 pr-0 text-xs">Missing receipt</span>
            <Button size="sm" variant="link" className="pl-0 font-bold" onClick={onUploadClick}>
              Add receipt
            </Button>
          </div>
        </div>
      </div>
      <p>${transaction.amount}</p>
    </>
  );
}
